import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="Finance engine settings" hint="Integration toggles, default VAT, fiscal year." /> }
